//
//
//
//
//
//
//
//
//
export default {
  name: 'SaleDetail',
  data: function data() {
    return {
      isRouterAlive: true
    };
  },
  created: function created() {
    console.log('created SaleDetail');
  },
  activated: function activated() {
    var _this = this;

    console.log('activated SaleDetail');
    this.isRouterAlive = false;
    this.$nextTick(function () {
      return _this.isRouterAlive = true;
    });
  }
};